import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useModelDeleteAsyncActionSuccess } from "./model-delete-async-action-success.hook";

export const ModelDeleteAsyncActionSuccess = () => {
  const { runAction } = useModelDeleteAsyncActionSuccess();
  useEventBusListener(
    BROADCAST_NOTIFICATION_TYPE.ASYNC_DELETE_SUCCESS,
    runAction
  );

  return <></>;
};
